import { Controller } from "@hotwired/stimulus"

// Top-level controller for the admin edit_full submission form. Mostly a no-op
// today — the heavy lifting lives in per-field controllers (signature, qr-scanner,
// edit-full-photo, product-installer, repeatable-section). Left in place so future
// cross-field behaviours (e.g. conditional logic, dirty-state tracking) have a home.
export default class extends Controller {}
